export default __webpack_public_path__ + "static/kyve-5400a79523579e109046abb93441a26b.svg";